export const SET_LOGIN_STATE = 'SET_LOGIN_STATE';
export const SET_LOGOUT_STATE = 'SET_LOGOUT_STATE';
